import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'

import { Error } from 'components'
import { useTranslate } from 'lib/tolgee'
import SmallGenericEmptyState from 'pages/TerritoryPage/components/SmallGenericEmptyState'
import { TOLGEE_GLOBALS } from 'utils'

import type { INichesOverviewSectionView } from './niches-overview-section.types'
import SubjectsList from '../../../pages/TerritoryPage/tabs/TerritoryOverview/components/Subjects/components/SubjectsList'
import SubjectsTitle from '../../../pages/TerritoryPage/tabs/TerritoryOverview/components/Subjects/components/SubjectsTitle'

const TOLGEE_PREFIX = 'Territory-Subjects'

export function NichesOverviewSectionView({
  isTerritoriesLoading,
  territoriesError,
  territoriesRefetch,
  isTrendingTag,
  territories,
  getURLFromTerritory,
  isUserViewer,
  handleTerritoryTrackClick,
  link,
}: INichesOverviewSectionView) {
  const t = useTranslate()

  if (isTerritoriesLoading) {
    return (
      <div className="TerritorySubjects-section">
        <SkeletonTheme baseColor="var(--color_neutral_400)" highlightColor="var(--color_neutral_200)">
          <div className="TerritorySubjects-loading">
            <Skeleton height={16} borderRadius={20} width={282} />
            <Skeleton height={10} borderRadius={20} width={229} />
          </div>
        </SkeletonTheme>
      </div>
    )
  }

  if (territoriesError) {
    return (
      <Error
        errorMessage={t(TOLGEE_GLOBALS.errorTextHeader)}
        handleError={territoriesRefetch}
        buttonText={t(TOLGEE_GLOBALS.retry)}
      />
    )
  }

  return (
    <div className="TerritorySubjects-section">
      {!isTrendingTag && (
        <SubjectsTitle tolgeeKey={`${TOLGEE_PREFIX}-nichesTitle`} linkUrl={link}>
          {'<link>Nichos</link> que estão engajando dentro deste território...'}
        </SubjectsTitle>
      )}

      {isTrendingTag && (
        <SubjectsTitle tolgeeKey={`${TOLGEE_PREFIX}-nichesTitleTrendingTag`} linkUrl="#">
          {'Nichos que estão engajando dentro deste território...'}
        </SubjectsTitle>
      )}

      {!territories?.length ? (
        <SmallGenericEmptyState
          title={t(TOLGEE_GLOBALS.noDataFound)}
          description={t(TOLGEE_GLOBALS.noDataFoundMessageSmall)}
        />
      ) : (
        <SubjectsList
          subjects={territories}
          onClick={getURLFromTerritory}
          isUserViewer={isUserViewer}
          onTrackClick={handleTerritoryTrackClick}
        />
      )}
    </div>
  )
}
